import { Card, CardContent } from "@/components/ui/library/card";
import QualificationHeader from "./components/QualificationHeader";
// import FilterSection from "./components/FilterSection";
import { Separator } from "@/components/ui/separator";
import QualificationCard from "./components/QualificationCard";
import AddQualificationModal from "../../modals/AddQualificationModal";
import EditQualificationModal from "../../modals/EditQualificationModal";
import useQualificationByLead from "../../api/useQualificationByLead";
import { useActiveDataMutation } from "@/features/leads/hook/useActiveDataMutation";

export default function Qualification() {
  const { lead } = useActiveDataMutation();
  // Ensure quals defaults to empty array to prevent map errors if undefined
  const { quals = [], isLoading } = useQualificationByLead(String(lead?.id));

  // Optional: Add a skeleton loader here if needed
  if (isLoading)
    return (
      <div className="p-8 text-center text-slate-400 text-sm">
        Loading qualifications...
      </div>
    );

  return (
    <div className="p-4">
      <Card className="px-0">
        <CardContent className="flex flex-col gap-4">
          <QualificationHeader />
          {/* <FilterSection /> */}
          <Separator />

          <div className="flex flex-col gap-4">
            {/* Handle Empty State */}
            {!isLoading && quals.length === 0 && (
              <div className="text-center py-8 text-slate-500 text-sm">
                No qualifications found.
              </div>
            )}

            {/* Map Real Data */}
            {quals.map((qual: any) => (
              <QualificationCard key={qual.id} data={qual} />
            ))}
          </div>
        </CardContent>
      </Card>

      <AddQualificationModal />
      <EditQualificationModal />
    </div>
  );
}
